import { PcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { DatePickerType } from '@/constants/datePicker';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  bizType?: BizType;
  targetId: string;
  calendarType: DatePickerType.WEEKLY | DatePickerType.MONTHLY | DatePickerType.YEARLY;
  startDate: string;
  endDate: string;
};

type BaseFirstOpenOrganizationStat = {
  partnerName: string;
  organizationName: string;
  settleId: string;
  productCode: string;
  requestCount: number;
  completeCount: number;
  completeRate: number;
  firstRequestDate: string;
};

export type EdocFirstOpenOrganizationStat = BaseFirstOpenOrganizationStat & {
  title: string;
};

export type Set4FirstOpenOrganizationStat = BaseFirstOpenOrganizationStat & { productName?: string };

export type FirstOpenOrganizationStat = EdocFirstOpenOrganizationStat | Set4FirstOpenOrganizationStat;
export type FirstOpenOrganizationStats = EdocFirstOpenOrganizationStat[] | Set4FirstOpenOrganizationStat[];

export type FirstOpenStats = {
  mostRequestedOrganization: string;
  firstOpenOrganizationStats: FirstOpenOrganizationStats;
};

export const getFirstOpen = (args: Args) => {
  if (!args.bizType) return Promise.resolve(null);
  return api<PcApiResponse<FirstOpenStats>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/statistics/organizations/first-open`,
    args
  );
};
